import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import type { ICampaignBudgetSummary } from '@brushfire/types'
import { instrumentApiPath } from '@/features/instruments/infra/instrumentPaths'
import { normalizeCampaignBudgetSummary } from '../lib/campaignBudgetLogic'

export async function fetchCampaignBudgetSummary(args: {
  instrumentId: string
  estimatedCost: number
}): Promise<ICampaignBudgetSummary> {
  const { data } = await apiClient.get<ApiResponse<ICampaignBudgetSummary>>(
    instrumentApiPath(args.instrumentId, '/campaign-budget-summary'),
    { params: { estimatedCost: args.estimatedCost } },
  )
  if (!data.success || !data.data) {
    throw new Error(data.message ?? 'Failed to load campaign budget summary')
  }
  return normalizeCampaignBudgetSummary(data.data)
}
